import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const PDF_CAPTURE_WIDTH = 1100;

export const waitForLayout = () =>
    new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

export const captureElementAsCanvas = async (element) => {
    if (!element) {
        throw new Error("Missing element for PDF capture");
    }

    await waitForLayout();

    const scale = Math.max(2, (PDF_CAPTURE_WIDTH / Math.max(element.offsetWidth, 1)) * 2);

    return html2canvas(element, {
        scale,
        windowWidth: PDF_CAPTURE_WIDTH,
        allowTaint: true,
    });
};

export const canvasToA4PdfDataUri = (canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdfWidth = 210;
    const pdfHeight = 297;
    const imgHeight = canvas.height * (pdfWidth / canvas.width);
    let heightLeft = imgHeight;
    let position = 0;

    const pdf = new jsPDF("portrait", "mm", "a4", true);
    pdf.scale = 2;

    while (heightLeft >= 0) {
        pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, imgHeight, undefined, "FAST");
        heightLeft -= pdfHeight;
        position -= pdfHeight;
        if (heightLeft >= 0) {
            pdf.addPage();
        }
    }

    return pdf.output("datauristring");
};
